export default __webpack_public_path__ + "static/media/Bhojpuri_agri2_m.7f288a25.wav";